import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './index.scss';

import SeButton from '../../../../components/SeButton';

const HelpMeChoose = ({ link, phrasecode }) => {
    const extraClass = classNames({
        [styles.HelpMeChoose]: true,
        [styles.HelpMeChooseBtn]: true,
        [styles.HelpMeChoosePrimary]: true,
        'help-me-choose-analytics': true,
    });

    return (
        <SeButton linkTo={link} block external extraClass={extraClass}>
            {phrasecode}
        </SeButton>
    );
};

HelpMeChoose.propTypes = {
    link: PropTypes.string.isRequired,
    phrasecode: PropTypes.string.isRequired,
};

export default HelpMeChoose;
